import {GetterTree} from 'vuex';
import {AuthorizationState} from '@/modules/authorization/store/index';
import {RootState} from '@/store/types';

const getters: GetterTree<AuthorizationState, RootState> = {
    /**
     * Indica un permiso se ha concedido
     *
     * @param state
     */
    granted: state => (path: string) => {
      return state.grantedPermissions.includes(path)
    },
}

export default getters
